import {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LibraryItemView} from "./LibraryItemView";
import {locations} from "../../Utilities/Location";
import {libraryCatalogApi} from "./libraryCatalogApi";
import {emptyResourceModel} from "./libraryFactory";
import {emptyGuid} from "../../Utilities/commonUtilities";
import {createListFromArrayOfObjects} from "../../Utilities/Types/listUtilities";
import type {ListItem} from "../../Utilities/Types/listUtilities";

export const LibraryItemContainer = ({
                                         handleApiCall,
                                         catalogItemId,
                                         redirect,
                                         systemType,
                                     }: ContextProps) => {
    const [item, setItem] = useState<Record<string, unknown>>();
    const [publishers, setPublishers] = useState<ListItem[]>();

    const handleReturn = () => {
        const selectedSystemType = systemType || item?.systemType;

        redirect(locations.LIBRARY_CATALOG.getLink(selectedSystemType).to)
    };

    const handleSaveResource = async (resource: Record<string, unknown>) => {

        return handleApiCall(() => libraryCatalogApi.saveResource(resource),
            handleReturn);
    };

    useEffect(() => {
        const newItem = {
            ...emptyResourceModel,
            systemType: systemType
        }
        const getResource = () => {
            handleApiCall(() => libraryCatalogApi.getResource(catalogItemId), (results = newItem) => setItem(results));
        }
        const getPublishers = () => {
            handleApiCall(() => libraryCatalogApi.getPublishers(), (results: Record<string, unknown>[]) =>
                setPublishers(createListFromArrayOfObjects(results, "publisherId", "name")));
        }

        if (!publishers)
            getPublishers();

        if (catalogItemId !== emptyGuid && !item)
            getResource();
        else
            setItem(newItem);

    }, [catalogItemId]);

    if (!item || !publishers) return <></>;

    return <>
        <PageTitle h1={`Library Item`}/>
        <LibraryItemView
            handleSaveResource={handleSaveResource}
            handleReturn={handleReturn}
            item={item}
            publishers={publishers}
        />
    </>;
};
